import { render, staticRenderFns } from "./RenewDetail.vue?vue&type=template&id=fb99361a&scoped=true&"
import script from "./RenewDetail.vue?vue&type=script&lang=js&"
export * from "./RenewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb99361a",
  null
  
)

export default component.exports